/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input, Button, Logo } from "@ht/components";
import TimeIcon from "@ht/shared/fonts/deos-pis/clock";
import clsx from "clsx";
import { useHttpRequest } from "../../hooks/useHttpRequest";
import { ChangePasswordContext } from ".";
import { toHHMMSS } from "@ht/shared/methods";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import * as chatActions from "../../app/chat/chatSlice";
import { login } from "../../app/auth/authThunk";

const OTPLoginPage = () => {
    const [otp, setOtp] = useState("");

    const [validationOTP, setValidationOTP] = useState("");
    const { token } = useAppSelector((state) => state.auth);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { sendRequest } = useHttpRequest();

    const customerBaseUrl = String(process.env.REACT_APP_AUTH_SERVICE);
    const cpCtx = useContext(ChangePasswordContext);
    const OTPTIMEOUT = 300;
    const [duration, setDuration] = useState(OTPTIMEOUT);
    const [allowInputOtp, setAllowInputOtp] = useState(true);
    const [intervalId, setIntervalId] = useState(0);
    let timer: number;

    useEffect(() => {
        if (token) {
            dispatch(chatActions.resetChatState());
            navigate("/");
        }
    }, [token, navigate]);

    const stopTimer = () => {
        console.log("stopping");
        window.clearInterval(intervalId);
    };
    const startTimer = () => {
        if (intervalId !== undefined) {
            console.log("start interval", duration);
            timer = window.setInterval(() => {
                if (duration > 0) setDuration((dur) => dur - 1);
            }, 1000);
            setIntervalId(timer);
        }
    };
    useEffect(() => {
        if (duration === OTPTIMEOUT && allowInputOtp && intervalId === 0)
            startTimer();
    }, [allowInputOtp]);
    useEffect(() => {
        if (duration === 0) {
            setAllowInputOtp(false);
            stopTimer();
            console.log("stoppng");
        }
    }, [duration]);
    const resendOTP = async (_username: string) => {
        await sendRequest({
            method: "post",
            url: `/forgotpassword/loginadministrator`,
            baseUrl: customerBaseUrl,
            body: {
                username: _username,
            },
        });
    };
    const submitOTP = async (otpParam: string) => {
        const dt = await sendRequest({
            method: "post",
            url: `/forgotpassword/submitotpforgotpassword`,
            baseUrl: customerBaseUrl,
            body: {
                email: cpCtx.mailAccount,
                otp: otpParam,
            },
        });
        if (dt.message === "otp_verified") {
            cpCtx.setName(dt.data[0].name);
            cpCtx.setUsername(dt.data[0].username);
            cpCtx.setOtp(otp);

            await dispatch(login({ username: cpCtx.loginUsername, password: cpCtx.loginPassword }));
        } else {
            setValidationOTP("Invalid OTP Code");
        }
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (otp === "") {
            setValidationOTP("Please input valid OTP");
        } else if (duration <= 0) {
            setValidationOTP("Invalid OTP Code");
        } else {
            await submitOTP(otp);
        }
    };

    return (
        <div className="signin-box w-full max-w-[400px]">
            <div className="absolute top-[0px] left-[0px] px-[24px] py-[32px]">
                <Logo className="mb-10 lg:mr-0" inverted={true} />
            </div>
            <h2 className="font-bold">Enter OTP Code</h2>
            <h3 className="font-light text-md text-gray-400 mb-[50px]">
                We sent an OTP code to {cpCtx.mailAccount ?? ""} please check your email and
                input the code below.
            </h3>

            <form onSubmit={handleSubmit}>
                <div className="form-group mb-8">
                    <span className="font-semibold text-black text-base">
                        OTP Code
                    </span>
                    <div
                        className={clsx(
                            "flex flex-row gap-[2px] items-center justify-between"
                        )}
                    >
                        <Input
                            autoComplete="off"
                            maxLength={6}
                            placeholder="●●●●●●"
                            className="border-0 !text-h1 font-bold text-black tracking-[14px] focus:bg-transparent"
                            id="inputotp"
                            type="text"
                            name="inputotp"
                            onChange={(e) => {
                                setOtp(e.target.value);
                            }}
                            value={otp}
                        ></Input>
                        <div className="text-md text-black font-semibold flex flex-row items-center gap-[8px]">
                            {allowInputOtp ? (
                                <>
                                    <TimeIcon className="text-primary w-[16px h-[16px]" />{" "}
                                    <span>{toHHMMSS(duration)}</span>
                                </>
                            ) : (
                                <Button
                                    type="button"
                                    variant="texted"
                                    color="danger"
                                    className="font-semibold text-md"
                                    onClick={() => {
                                        resendOTP(cpCtx.mailAccount).catch(
                                            () => { }
                                        );
                                        stopTimer();
                                        setDuration(OTPTIMEOUT);
                                        setIntervalId(0);
                                        setAllowInputOtp(true);
                                    }}
                                >
                                    Resend
                                </Button>
                            )}
                        </div>
                    </div>

                    <span className="text-danger font-semibold mb-[8px]">
                        {validationOTP}
                    </span>
                </div>

                <Button
                    type="submit"
                    fullwidth
                    className="rounded-lg text-sm uppercase tracking-wider border-0 min-h-[40px] mb-4 bg-gradient-to-r from-primary to-purple bg-repeat-x"
                >
                    <span className="text-md font-semibold text-white normal-case">
                        Verify
                    </span>
                </Button>
            </form>
            <span className="text-gray-300 center flex flex-col items-center">
                <div>
                    Back to login page?{" "}
                    <button
                        className="text-gray-400 hover:underline hover:cursor-pointer hover:text-primary"
                        onClick={() => navigate("/signin")}
                        onKeyDown={() => { }}
                        tabIndex={0}
                    >
                        Back
                    </button>
                </div>
            </span>
        </div>
    );
};

export default OTPLoginPage;